<template>
  <div class="examresult">
    <table-list
      ref="tableList"
      title="考试成绩"
      :loading="loading"
      :search-form="searchForm(this)"
      :data="examResult"
      :footer-btns="footerBtns(this)"
      :columns="columns(this)"
      :operates="operates(this)"
      :pager="pager"
      :options="{ selection: true, operatesWidth: 100 }"
      @search="onSearch"
      @selectionChange="handleSelectionChange"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></table-list>
  </div>
</template>
<script>
// 底部按钮
const footerBtns = _this => [
  {
    label: '导出全部',
    icon: 'el-icon-download',
    method: _this.exportTable,
  },
  {
    label: '导出考试答题详情',
    icon: 'el-icon-download',
    method: _this.exportExamDetail,
  },
]
// 搜索框配置
const searchForm = _this => [
  {
    label: 'ID/姓名/手机号/身份证/准考证',
    prop: 'keyWord',
  },
  {
    placeholder: '考试计划-考试科目',
    type: 'treeSelect',
    prop: 'examSubjectMaps',
    options: _this.examSubjectList,
    optionProps: {
      // value: 'id',
      // label: 'examPlanName',
      children: 'learnLevels',
      checkStrictly: true,
      lazy: true,
      lazyLoad: _this.treeLazyLoad,
    },
    defaultValue: _this.examId,
  },
  {
    label: '职业',
    type: 'select',
    prop: 'jobId',
    children: _this.jobLevelList.map(item => ({
      value: item.id,
      label: item.jobName,
    })),
  },
  {
    label: '类型',
    type: 'select',
    prop: 'subjectType',
    children: [
      { value: '2', label: '理论' },
      { value: '1', label: '实操' },
    ],
  },
  {
    placeholder: '交卷时间',
    type: 'picker',
    prop: 'examTime',
  },
  // {
  //   label: '是否及格',
  //   type: 'select',
  //   prop: 'passFlag',
  //   children: [
  //     { value: '1', label: '通过' },
  //     { value: '2', label: '未通过' },
  //   ],
  // },
]
// 表格列配置
const columns = () => [
  {
    prop: 'userName',
    label: '考试姓名',
    minWidth: 80,
  },
  {
    prop: 'phone',
    label: '手机号',
    minWidth: 110,
  },
  {
    prop: 'idCard',
    label: '身份证号',
    minWidth: 170,
  },
  {
    prop: 'admissionTicketId',
    label: '准考证号',
    minWidth: 170,
  },
  {
    prop: 'examPlanName',
    label: '考试计划',
    twoLines: true,
    minWidth: 200,
  },
  {
    prop: 'examSubjectName',
    label: '考试科目',
    twoLines: true,
    minWidth: 200,
  },
  {
    prop: 'jobName',
    label: '职业',
    minWidth: 180,
  },
  {
    prop: 'subjectTypeName',
    label: '类型',
    minWidth: 70,
  },
  {
    prop: 'objectiveScore',
    label: '客观题得分',
    minWidth: 110,
  },
  {
    prop: 'subjectiveScore',
    label: '主观题得分',
    minWidth: 110,
  },
  {
    prop: 'spendTimeShow',
    label: '考试时长',
    minWidth: 110,
  },
  {
    prop: 'finalScore',
    label: '考试得分',
    minWidth: 110,
  },
  {
    prop: 'paperScore',
    label: '考试总分',
    minWidth: 110,
  },
  {
    prop: 'startTime',
    label: '开始时间',
    sortdata: 1,
    minWidth: 110,
  },
  {
    prop: 'submitTime',
    label: '交卷时间',
    sortdata: 2,
    minWidth: 110,
  },
]
// 表格操作按钮配置
const operates = _this => [
  {
    method: _this.handleDetail,
    label: '详情',
  },
]
import TableList from '@/components/TableList'
import to from 'await-to'
import {
  examresultPlanDropDown,
  examresultSubjectDropDown,
  filterJobLevel,
  examRecordPage,
  examRecordExport,
  examRusltExport,
} from '@/api/exam'
export default {
  name: 'ExamResult',
  components: {
    TableList,
  },
  data() {
    return {
      searchForm,
      footerBtns,
      columns,
      operates,
      loading: false,
      examResult: [],
      selectExamResult: [],
      pager: {
        total: 0,
        size: 20,
        current: 1,
      },
      queryParams: {},
      examSubjectList: [],
      planId: this.$route.query.planId || '',
      examId: [],
      jobLevelList: [],
    }
  },
  mounted() {
    this.getJobLevel()
    if (this.planId) {
      this.examId.push(this.planId - 0)
      this.queryParams.examPlanId = this.planId
    }
    this.handleExamRecordPage()
  },
  methods: {
    async treeLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      if (node.level == 0) {
        const [res, err] = await to(examresultPlanDropDown())
        if (err) return this.$message.warning(err.msg)
        const nodes = res.data.map(item => ({
          ...item,
          value: item.id,
          label: item.examPlanName,
        }))
        resolve(nodes)
      } else if (node.level == 1) {
        const [res, err] = await to(examresultSubjectDropDown({ planId: node.data.id }))
        if (err) return this.$message.warning(err.msg)
        const nodes = res.data.map(item => ({
          ...item,
          value: item.id,
          label: item.examSubjectName,
        }))
        resolve(nodes)
      } else {
        resolve()
      }
    },
    async getJobLevel() {
      const [res, err] = await to(filterJobLevel({}))
      if (err) return this.$message.warning(err.msg)
      this.jobLevelList = res.data
    },
    async handleExamRecordPage() {
      if (this.loading) return
      const { current, size } = this.pager
      this.loading = true
      const [res, err] = await to(examRecordPage({ current, size, ...this.queryParams }))
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.examResult = res.data.list
      this.pager.total = res.data.total
    },
    // 查询按钮
    onSearch(queryParams) {
      if (queryParams.examSubjectMaps.length == 0) {
        queryParams.examPlanId = ''
        queryParams.examSubjectId = ''
      } else if (queryParams.examSubjectMaps.length == 1) {
        queryParams.examPlanId = queryParams.examSubjectMaps[0]
        queryParams.examSubjectId = ''
      } else if (queryParams.examSubjectMaps.length == 2) {
        queryParams.examPlanId = queryParams.examSubjectMaps[0]
        queryParams.examSubjectId = queryParams.examSubjectMaps[1]
      }
      if (queryParams.examTime && queryParams.examTime.length !== 0) {
        queryParams.submitBeginTime = queryParams.examTime[0]
        queryParams.submitEndTime = queryParams.examTime[1].split(' ')[0] + ' 23:59:59'
      } else {
        queryParams.submitBeginTime = ''
        queryParams.submitEndTime = ''
      }
      this.pager.current = 1
      this.queryParams = queryParams
      this.handleExamRecordPage()
    },
    //底部导出
    async exportTable() {
      let arr = []
      if (this.selectExamResult.length) this.selectExamResult.map(v => arr.push(v.id))
      const { current, size } = this.pager
      const [res, err] = await to(
        examRecordExport({
          current,
          size,
          ids: arr,
          ...this.queryParams,
        }),
      )
      if (err) return this.$message.warning(err.msg)
      let blob = new Blob([res], {
        type: 'application/vnd.ms-excel',
      })
      let url = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.href = url
      a.download = '考试成绩.xlsx'
      a.click()
      window.URL.revokeObjectURL(url)
    },
    async exportExamDetail() {
      // 未点击查询时，也取搜索栏当前选中的值
      const { examSubjectMaps = [] } = this.$refs.tableList.$refs.tableSearchBar.searchData
      const [examPlanId = '', examSubjectId = ''] = examSubjectMaps
      const [res, err] = await to(
        examRusltExport({
          examPlanId,
          examSubjectId,
        }),
      )
      console.log(res, err)
      if (err) return this.$message.warning(err.msg)
      let blob = new Blob([res], {
        type: 'application/vnd.ms-excel',
      })
      let url = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.href = url
      a.download = '考试答题详情.xlsx'
      a.click()
      window.URL.revokeObjectURL(url)
    },
    //详情
    handleDetail(row) {
      this.$router.push({
        path: '/exam/result/detail',
        query: { id: row.id },
      })
    },
    // 分页
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.handleExamRecordPage()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.handleExamRecordPage()
    },
    handleSelectionChange(val) {
      this.selectExamResult = val
    },
  },
}
</script>
<style scoped lang="scss">
.examresult {
  ::v-deep .table-list {
    .form {
      .el-form-item .el-input {
        width: auto !important;
        .el-input__inner {
          width: 260px !important;
        }
      }
      .el-cascader .el-input,
      .el-select .el-input {
        width: auto !important;
        .el-input__inner {
          width: 220px !important;
        }
      }
      .el-date-editor {
        width: 240px !important;
      }
    }
    .footer {
      .btns {
        .el-button {
          width: auto;
          min-width: 100px;
          padding: 0 15px;
        }
      }
    }
  }
}
</style>
